<template>
    <div class="row">
        <div class="col-lg-8">
            <div class="big-underline-ttl">
                <h3 class="">your order</h3>
                <a href="print-invoice.html" class="print-btn">
                    <img src="/img/print.svg" alt="">
                    <span>Print</span>
                </a>
            </div>
            <div class="booking-box-block">
                <p class="mb-0">Your rent order was successfully placed on 20/06/21.</p>
                <p class="mb-3"> Your confirmation email has been sent to <span class="color--primary">alex@gmail.com</span></p>
                <div class="order-table-wrap">
                    <table class="table order-table" tabindex="0">
                        <thead>
                        <tr>
                            <th colspan="2">Item</th>
                            <th>Price</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="first-row">
                            <td >
                                <p><strong>22' Pontoon Boat Rental  × 1</strong></p>
                            </td>
                            <td > </td>
                            <td >
                                <p>$550.00</p>
                            </td>

                        </tr>
                        <tr>
                            <td >
                                <p>Booking Date:</p>
                            </td>
                            <td >
                                <p>June 25, 2021</p>
                            </td>
                            <td >

                            </td>

                        </tr>
                        <tr>
                            <td >
                                <p>Booking Time:</p>
                            </td>
                            <td >
                                <p>10:00 am</p>
                            </td>
                            <td >

                            </td>

                        </tr>
                        <tr>
                            <td >
                                <p>Duration:</p>
                            </td>
                            <td >
                                <p> 4 hours</p>
                            </td>
                            <td >

                            </td>

                        </tr>
                        <tr>
                            <td >
                                <p> Pick Up Location:</p>
                            </td>
                            <td >
                                <p>900 N Ocean Drive Hollywood, Florida 33019</p>
                            </td>
                            <td >

                            </td>

                        </tr>
                        <tr>
                            <td >
                                <p>Appointment:</p>
                            </td>
                            <td >
                                <p>Hire Captain</p>
                            </td>
                            <td >
                                <p>$150.00</p>
                            </td>

                        </tr>
                        <tr>
                            <td >
                                <p> # of Adults and Children:</p>
                            </td>
                            <td >
                                <p>6</p>

                            </td>
                            <td >

                            </td>

                        </tr>
                        <tr>
                            <td class="pb-3">
                                <p>Age of each child under 13 years:</p>
                            </td>
                            <td class="pb-3">
                                <p>8, 9</p>
                            </td>
                            <td class="pb-3"> </td>

                        </tr>
                        <tr class="sub-total-row" >
                            <td colspan="2">
                                <p>Subtotal: </p>
                            </td>
                            <td >
                                <p>$700.00</p>
                            </td>
                        </tr>
                        <tr class="tax-row" >
                            <td colspan="2">
                                <p>FL. 7% Tax:</p>
                            </td>
                            <td >
                                <p>$10.00</p>
                            </td>
                        </tr>
                        <tr class="total-row" >
                            <td colspan="2">
                                <p><strong>Total:</strong></p>
                            </td>
                            <td >
                                <p><strong>$710.00</strong></p>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                </div>

            </div>
        </div>
        <div class="col-lg-4">
            <div class="fixed-block">
                <div class="summary-block">
                    <div class="box">
                        <div class="box-offset">
                            <h3 class="mb-0">Payment Details</h3>
                            <div class="separation-small"></div>
                            <div class="payment-info">
                                <img src="/img/card-1.png" alt="" class="card-img">
                                <div class="pr-4">
                                    <strong>Julia Robemson</strong>
                                </div>
                                <div>
                                    <p>****1234</p>
                                    <p>Expiry: 12.2022</p>
                                </div>
                                <div class="mt-4">
                                    <div class="">
                                        <strong>Billing Address: </strong>
                                    </div>
                                    <div>
                                        <p>
                                            900 N Lorem <br>
                                            Miami, Florida 33019<br>
                                            123.123.1234<br>
                                            alex@gmail.com
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="mt-5">
                        <a href="/#boats-rent" class="btn btn--primary-outline w-100">continue rent</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OrderReview"
    }
</script>
